module.exports = __webpack_public_path__ + "img/checkmark.a7c6f752.svg";